import { render, staticRenderFns } from "./Photo.vue?vue&type=template&id=9026f1e0&scoped=true"
var script = {}
import style0 from "./Photo.vue?vue&type=style&index=0&id=9026f1e0&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9026f1e0",
  null
  
)

export default component.exports